import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mb-10" }, "Dados básicos", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mb-2" }, "Pix para faturas", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5" }, "Contas bancárias", -1)

import { ref, reactive, inject, onMounted } from 'vue';
import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import rules from '@/app/shared/domain/data/rules';
import InputAddress from '@/app/shared/components/inputs/InputAddress.vue';
import InputAvatar from '@/app/shared/components/inputs/InputAvatar.vue';
import InputDocument from '@/app/shared/components/inputs/InputDocument.vue';
import InputBankAccount from '@/app/shared/components/inputs/InputBankAccount.vue';
import CompanyRepository from '@/app/my-company/infrastructure/persistence/CompanyRepository';
import Tabs from '@/app/shared/components/Tabs.vue';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';
import useOverlayState from '@/app/shared/infrastructure/state/overlay';
import MyCompany from '@/app/my-company/domain/interfaces/MyCompany';
import CnpjData from '@/app/shared/domain/classes/CnpjData';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyCompanyForm',
  setup(__props) {

const overlayState = useOverlayState();
const notificationRepository = useNotificationRepository();
const repository = inject('companyRepository') as CompanyRepository;
const picture = ref(null);
const qrcode = ref(null);
const form = ref(null);
const data = reactive({company: {
    image: 'default.jpg',
} as MyCompany});

onMounted(async () => {
    data.company = await repository.get();
});

const matrizOptions = [
    { title: 'Sim', value: true, },
    { title: 'Não', value: false, },
];

const legalNatureOptions = [
    { title: 'Empresário individual (EI)', value: 'ei', },
    { title: 'Empresa individual de responsabilidate limitada (EIRELI)', value: 'eireli', },
    { title: 'Sociedade simples (SS)', value: 'ss', },
    { title: 'Sociedade empresária limitada (LTDA)', value: 'ltda', },
    { title: 'Sociedade anônima (SA)', value: 'sa', },
];

const submit = async () => {
    const {valid} = await form.value.validate();

    if (valid) {
        overlayState.set(true);
        const formData = new FormData();
        if (picture.value) {
            formData.append('image', picture.value);
        }

        if (qrcode.value) {
            formData.append('qrcode', qrcode.value);
        }

        formData.append('data', JSON.stringify(data.company));

        await repository.update(formData);

        overlayState.set(false);

        notificationRepository.insert({
            id: Date.now().toString(),
            type: 'success',
            message: 'Atualizado com sucesso.',
        });
    } else {
        notificationRepository.insert({
            id: Date.now().toString(),
            type: 'warning',
            message: 'Existem campos inválidos.',
        });
    }
};

function handleRemoveAccount(index: number): void {
    data.company.account_list = data.company.account_list.filter((item, i) => i !== index);
}

function handleAddAccount(): void {
    data.company.account_list.push({
        code_bank: '',
        agency: '',
        pix_key: '',
        number: '',
    });
}

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-map-marker',
        key: 'address',
        title: 'Endereço'
    },
    {
        icon: 'mdi:mdi-plus-circle-outline',
        key: 'accounts',
        title: 'Contas'
    },
];

function cnpjDataFound(cnpjData: CnpjData) {
    data.company.name = cnpjData.name;
    data.company.email = cnpjData.email;
    data.company.phone = cnpjData.phone;
    data.company.address = {
        zip_code: cnpjData.zipCode,
        street: cnpjData.street,
        number: cnpjData.number,
        complement: cnpjData.complement ?? '',
        neighborhood: cnpjData.neighborhood,
        city: cnpjData.city,
        state: cnpjData.state,
    };
}

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: submit,
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Minha empresa ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, { wrap: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "2",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputAvatar, {
                                    "image-path": "companies",
                                    src: data.company.image,
                                    modelValue: picture.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((picture).value = $event))
                                  }, null, 8, ["src", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "10"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_1,
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(InputDocument, {
                                        modelValue: data.company.document,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.company.document) = $event)),
                                        onCnpjDataFound: cnpjDataFound
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required],
                                            label: "Nome",
                                            modelValue: data.company.name,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.company.name) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Nome fantasia",
                                            modelValue: data.company.fantasy_name,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.company.fantasy_name) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Email",
                                            rules: [_unref(rules).email],
                                            modelValue: data.company.email,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.company.email) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Nome do responsável",
                                            modelValue: data.company.responsible_name,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.company.responsible_name) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Telefone",
                                            rules: [_unref(rules).phone],
                                            modelValue: data.company.phone,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.company.phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)####-####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Celular / Whatsapp",
                                            rules: [_unref(rules).phone],
                                            modelValue: data.company.cell_phone,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.company.cell_phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)#####-####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Cnae principal",
                                            rules: [_unref(rules).cnae],
                                            modelValue: data.company.cnae,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.company.cnae) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '####-#/##']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "FPAS",
                                            modelValue: data.company.fpas,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.company.fpas) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: data.company.legal_nature,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((data.company.legal_nature) = $event)),
                                            label: "Natureza jurídica",
                                            items: legalNatureOptions
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Inscrição estadual",
                                            modelValue: data.company.state_registration,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((data.company.state_registration) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Inscrição municipal",
                                            modelValue: data.company.municipal_registration,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((data.company.municipal_registration) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: data.company.matriz,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((data.company.matriz) = $event)),
                                            modelModifiers: { boolean: true },
                                            label: "Matriz",
                                            items: matrizOptions
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        address: _withCtx(() => [
                          _createVNode(InputAddress, {
                            modelValue: data.company.address,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((data.company.address) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        accounts: _withCtx(() => [
                          _hoisted_2,
                          _createVNode(InputAvatar, {
                            "image-path": "qrcodes",
                            src: data.company.qrcode,
                            modelValue: qrcode.value,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((qrcode).value = $event))
                          }, null, 8, ["src", "modelValue"]),
                          _createVNode(_component_v_divider, { class: "my-5" }),
                          _hoisted_3,
                          _createVNode(_component_v_row, { justify: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: handleAddAccount,
                                class: "align-self-end",
                                "prepend-icon": "fas fa-plus"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Adicionar conta")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.company.account_list, (account, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              _createVNode(InputBankAccount, {
                                modelValue: data.company.account_list[index],
                                "onUpdate:modelValue": ($event: any) => ((data.company.account_list[index]) = $event),
                                class: "mt-5"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_v_btn, {
                                onClick: ($event: any) => (handleRemoveAccount(index)),
                                color: "red",
                                "prepend-icon": "fas fa-trash",
                                class: "mb-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Excluir")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_divider)
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})